import * as XLSX from '@stackline/xlsx';

export const centralLogColumns = [
  'Flight Number',
  'Date',
  'Name',
  'Dep Airfield / Arr Airfield',
  'Dep Time',
  'Arr Time',
  'Flight Hours',
  'Fuel Uplift',
  'Oil uplift',
  'Sig',
  'Nxt Check',
  'defects',
  'Rect',
  'Eng Sig',
  'Remarks',
];

export function createCentralTechLogWorkbook(rows) {
  const worksheetData = [
    centralLogColumns,
    ...rows.map((row) => centralLogColumns.map((column) => row[column] ?? '')),
  ];
  const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
  worksheet['!cols'] = centralLogColumns.map((column) => ({
    wch: Math.max(
      String(column).length + 2,
      ...rows.map((row) => String(row[column] ?? '').length + 2),
    ),
  }));
  worksheet['!rows'] = [{ hpt: 20 }];
  worksheet['!autofilter'] = {
    ref: `A1:${XLSX.utils.encode_col(centralLogColumns.length - 1)}1`,
  };
  worksheet['!margins'] = {
    left: 0.3,
    right: 0.3,
    top: 0.4,
    bottom: 0.4,
    header: 0.2,
    footer: 0.2,
  };
  worksheet['!printArea'] = worksheet['!ref'];
  worksheet['!pageSetup'] = {
    orientation: 'landscape',
    fitToWidth: 1,
    fitToHeight: 0,
    paperSize: 9,
    horizontalCentered: true,
    verticalCentered: false,
    printTitlesRow: '1:1',
  };

  const workbook = XLSX.utils.book_new();
  workbook.Workbook = workbook.Workbook || {};
  workbook.Workbook.Views = [{ RTL: false }];
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Tech Log');
  return workbook;
}

export function downloadCentralTechLogXlsx(rows, filename) {
  XLSX.writeFile(createCentralTechLogWorkbook(rows), filename);
}
